import { Guid } from 'js-guid';
import { CONTENT_ITEM_KEYS } from '../../features/CreateContent/constants.js';

export const mapContentItems = (data, isExistLocale, oldData) => {
  let isExistSlider = false;
  const body = new FormData();

  if (isExistLocale) {
    isExistSlider = oldData.find((i) => i.guid === data.guid);
  }

  const items = data.images.map((z) => {
    console.log(isExistSlider);
    const isExistImage = isExistSlider && isExistSlider.images.find((v) => v.guid === z.guid);

    if (isExistImage) {
      console.log('find exist image', isExistImage);
      return isExistImage;
    }

    const guid = Guid.newGuid().toString();
    body.append(guid, z.imgPath);
    return { imgPath: '', guid: guid, discriminator: 'ImageContentItem' };
  });
  return {
    content: body.entries(),
    model: items,
  };
};

export const mapContentAudio = (data, oldData) => {
  if (data[CONTENT_ITEM_KEYS[data.discriminator]]) {
    const isExist = oldData.find((i) => i.guid === data.guid);
    console.log(data, isExist);

    if (isExist)
      return {
        isUpdateAudio: false,
      };

    return {
      isUpdateAudio: true,
    };
  }
  return {
    isUpdateAudio: false,
  };
};
